import type { UseMutationOptions } from "@tanstack/react-query";

//* Define your query config here
export const queryConfig = {
	queries: {
		// throwOnError: true,
		refetchOnWindowFocus: false,
		retry: false,
		staleTime: 1000 * 60 * 5,
	},
};

// Custom error type
export type NormalizedError = Error & {
	title?: string;
	message?: string;
};

export type ApiFnReturnType<FnType extends (...args: any) => Promise<any>> = Awaited<ReturnType<FnType>>;

export type QueryConfig<T extends (...args: any[]) => any> = Omit<ReturnType<T>, "queryKey" | "queryFn">;

export type MutationConfig<MutationFnType extends (...args: any) => Promise<any>> = UseMutationOptions<
	ApiFnReturnType<MutationFnType>,
	NormalizedError,
	Parameters<MutationFnType>[0]
>;
